import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Transition as _Transition, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "pr-l-2 pr-xl-2 pr-mb-1" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col d-flex align-items-center" }
const _hoisted_4 = { class: "card-title mb-3 float-left" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Datos de llamada ")
const _hoisted_6 = { class: "text-muted font-weight-normal ml-1" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-sync" })
], -1)
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col mt--3 mb-3 d-flex" }
const _hoisted_10 = {
  class: "text-muted d-block",
  style: {"font-size":"0.8rem"}
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("b", null, [
  /*#__PURE__*/_createElementVNode("em", null, "Fecha y hora: ")
], -1)
const _hoisted_12 = {
  key: 0,
  class: "float-sm-right mt--3"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createTextVNode(" Identificadores "),
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-plus ml-1" })
], -1)
const _hoisted_14 = { class: "d-flex align-items-center" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Modificar usuario ")
const _hoisted_16 = { class: "d-flex align-items-center" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Crear Usuario ")

import { Tools, CirclePlusFilled } from "@element-plus/icons";
import { ref, computed, defineAsyncComponent } from "vue";
import { CallDataModule } from "@/store/modules/CallData";
import CampaingInfo from "@/callcenter/components/CampaignInfo.vue";
import UserIdentifiersForm from "./UserIdentifiersForm.vue";
import { env } from "@/config";
import { coreApi } from "@/conection";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const UserForm = defineAsyncComponent(() =>
	env.DynamicUser
		? import(/* webpackChunckName: "userdynamicform" */ "./UserDynamicForm.vue")
		: import(/* webpackChunckName: "userdynamicform" */ "./UserDefaultForm.vue")
);
const UserData = defineAsyncComponent(() =>
	env.DynamicUser
		? import(
				/* webpackChunckName: "userData" */
				"./UserDynamicData.vue"
		  )
		: import(/* webpackChunckName: "userData" */ "./UserDefaultData.vue")
);

const scorign = computed(() => {
	return CallDataModule.scoring;
});
const activeCall = computed(() => {
	return CallDataModule.activeCall;
});
const isNewUser = computed(() => {
	return CallDataModule.IsNewUser;
});
const key = ref(0);

const model = ref({
	modal: false,
	channel: "",
	identifiers: false,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any

/* const options = computed(() => {
	return CallDataModule.Channels
		? CallDataModule.Channels.map(a => ({
				value: a,
				label: a.name?.toLowerCase(),
				disabled: !a.active,
				// eslint-disable-next-line no-mixed-spaces-and-tabs
		  }))
		: [];
}); */
/* const copyText = () => {
	navigator.clipboard.writeText(activeCall.value.uniqueid);
}; */

function getActiveCall() {
	coreApi.post("/api/log", {
		user: CallDataModule.user,
		isNewUser: CallDataModule.IsNewUser,
	});
	CallDataModule.setScore(false);
	key.value += 1;
	CallDataModule.updateActiveCall({ force: true });
}

return (_ctx: any,_cache: any) => {
  const _component_base_button = _resolveComponent("base-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_card, null, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock("div", {
            class: "card-body mb-1",
            key: key.value
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h2", _hoisted_4, [
                  _hoisted_5,
                  _createElementVNode("small", _hoisted_6, _toDisplayString(_unref(activeCall).userChanId ?? _unref(activeCall).uniqueid), 1)
                ]),
                _createVNode(_component_el_tooltip, { content: "Consultar datos de llamada" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_base_button, {
                      class: "ml-auto",
                      type: "warning",
                      size: "sm",
                      disabled: !_unref(scorign),
                      onClickCapture: getActiveCall
                    }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _: 1
                }),
                (_unref(env).CampaingInfo)
                  ? (_openBlock(), _createBlock(CampaingInfo, { key: 0 }))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("small", _hoisted_10, [
                  _hoisted_11,
                  _createTextVNode(" " + _toDisplayString(_unref(activeCall).call_date), 1)
                ])
              ])
            ]),
            _createVNode(_unref(UserData)),
            (_unref(activeCall).call_number.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  (!_unref(env).onlyCallcenter && _unref(scorign))
                    ? (_openBlock(), _createBlock(_component_base_button, {
                        key: 0,
                        type: "primary",
                        size: "sm",
                        onClickCapture: _cache[0] || (_cache[0] = ($event: any) => (model.value.identifiers = true))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_13
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (!_unref(isNewUser))
                    ? (_openBlock(), _createBlock(_component_base_button, {
                        key: 1,
                        size: "sm",
                        type: "warning",
                        onClickCapture: _cache[1] || (_cache[1] = ($event: any) => (model.value.modal = true))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_14, [
                            _createVNode(_component_el_icon, {
                              size: 20,
                              color: "#FFFFF",
                              class: "no-inherit"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(Tools))
                              ]),
                              _: 1
                            }),
                            _hoisted_15
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_unref(isNewUser))
                    ? (_openBlock(), _createBlock(_component_base_button, {
                        key: 2,
                        size: "sm",
                        type: "primary",
                        onClickCapture: _cache[2] || (_cache[2] = ($event: any) => (model.value.modal = true))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_16, [
                            _createVNode(_component_el_icon, {
                              size: 20,
                              color: "#FFFFF",
                              class: "no-inherit"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(CirclePlusFilled))
                              ]),
                              _: 1
                            }),
                            _hoisted_17
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]))
        ]),
        _: 1
      })
    ]),
    _createVNode(_Transition, {
      "enter-active-class": "miniFadeInUp",
      "leave-active-class": "miniFadeOutUp"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(UserForm), {
          "model-value": model.value.modal,
          "onUpdate:model-value": _cache[3] || (_cache[3] = ($event: any) => ((model.value.modal) = $event))
        }, null, 8, ["model-value"])
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      "enter-active-class": "miniFadeInUp",
      "leave-active-class": "miniFadeOutUp"
    }, {
      default: _withCtx(() => [
        (_unref(CallDataModule).user?._id)
          ? (_openBlock(), _createBlock(UserIdentifiersForm, {
              key: 0,
              "model-value": model.value.identifiers,
              "onUpdate:model-value": _cache[4] || (_cache[4] = ($event: any) => ((model.value.identifiers) = $event))
            }, null, 8, ["model-value"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})